import { IAiPendingStatuses } from '@diana/core';
import {
  IDndLayoutComponentLocation,
  IDndLayoutComponentDragObject,
} from '../../../providers/DndLayoutComponents2';

export enum BuilderToolsDrawerTabValue {
  Explorer = 'explorer',
  Rules = 'rules',
  Properties = 'properties',
}

export enum BuilderConfigureEditorTabEnum {
  AskDiana = 'askDiana',
  Configuration = 'Configuration',
}

export enum BuilderTypeEnum {
  Nocode = 'Nocode',
  AdvancedEditor = 'AdvancedEditor',
}

export enum FlowBuilderModalContentTypeEnum {
  UpdateAssetValue = 'UpdateAssetValueActivityEditor',
  AdvancedEditor = 'AdvancedEditor',
  AiAcceptReject = 'AiAcceptReject',
}

export type TFlowBuilder2PageModalMap = {
  [FlowBuilderModalContentTypeEnum.AdvancedEditor]: {};
  [FlowBuilderModalContentTypeEnum.AiAcceptReject]: {};
  [FlowBuilderModalContentTypeEnum.UpdateAssetValue]: {
    taskId: string;
    actionSetId: string;
    actionId: string;
    activityIndex: number;
  };
};

export type TFlowBuilder2PageModal = {
  [K in keyof TFlowBuilder2PageModalMap]: { name: K; context: TFlowBuilder2PageModalMap[K] };
}[keyof TFlowBuilder2PageModalMap];

export type TActiveComponent = { componentId: string; layoutId: string };

export interface IFlowBuilder2PageStore {
  /**
   * task that is being configured;
   * Determines if configure task drawer is open
   */
  activeTaskId: string | null;
  setActiveTaskId: (activeTask: IFlowBuilder2PageStore['activeTaskId']) => void;

  /**
   * component that is being configured;
   * Determines if configure component drawer is open
   */
  activeComponent: TActiveComponent | null;
  getActiveComponent: () => IFlowBuilder2PageStore['activeComponent'];
  setActiveComponent: (activeComponent: IFlowBuilder2PageStore['activeComponent']) => void;

  resetActiveContext: () => void;

  /**
   * Mapping of collapsed tasks
   * Determines if a task panel is collapsed
   */
  collapsedTasksMap: Partial<Record<string, true>>;
  setTaskCollapsed: (taskId: string, collapsed: boolean) => void;

  /**
   * Stores the layout component that is being dragged
   */
  layoutDndDragItem: IDndLayoutComponentDragObject | null;
  getLayoutDndDragItem: () => IDndLayoutComponentDragObject | null;
  setLayoutDndDragItem: (dragItem: IDndLayoutComponentDragObject | null) => void;

  isScrollingDndDragItem: boolean;
  setIsScrollingDndDragItem: (value: boolean) => void;

  /**
   * In UX/UI it's expected that one drop placeholder should appear at a time
   * Determines if what location is the active drop placeholder
   */
  layoutDndPlaceholderLocation: IDndLayoutComponentLocation | null;
  getLayoutDndPlaceholderLocation: () => IDndLayoutComponentLocation | null;
  setLayoutDndPlaceholderLocation: (position: IDndLayoutComponentLocation | null) => void;

  /**
   * Controls the modal for the flow builder page
   */
  activeModal: TFlowBuilder2PageModal | null;
  setActiveModal: (activeModal: TFlowBuilder2PageModal | null) => void;

  reset: () => void;

  /**
   * Store states for Ai Pending statuses
   */
  draftInView: string[];
  setDraftInView: (payload: string[]) => void;
  addDraftInView: (layoutId: string) => void;
  removeDraftInView: (layoutId: string) => void;
  isScrolling: boolean;
  setIsScrolling: (payload: boolean) => void;

  aiPendingStatuses: IAiPendingStatuses;
  setAiPendingStatuses: (payload: IAiPendingStatuses) => void;
  resetEditPending: () => void;
  hasAnyPendingStatus: () => boolean;

  /**
   * Store states for left / right drawer
   */
  rightDrawerActiveTab: BuilderConfigureEditorTabEnum;
  setRightDrawerActiveTab: (payload: BuilderConfigureEditorTabEnum) => void;
  leftDrawerActiveTab: BuilderToolsDrawerTabValue | null;
  setLeftDrawerActiveTab: (payload: BuilderToolsDrawerTabValue) => void;
  builderType: BuilderTypeEnum;
  setBuilderType: (builderTab: BuilderTypeEnum) => void;
  taskActionIndex: number;
  setTaskActionIndex: (payload: number) => void;
}
